/* RR product page v2 — gallery, lightbox, LED frame-rate meters, reviews jump.
   Paired with sections/rr-product.liquid + assets/rr-product.css */
(function () {
  if (window.__rrProduct) return;
  window.__rrProduct = true;

  var MAX = 360;
  var TIERS = [[200, 'EPIC', '#FF2AAC'], [143.999, 'EXCELLENT', '#c084fc'], [59.999, 'SOLID', '#29E3FF'], [-1, 'LOW', '#A68BBD']];
  function tier(v) { for (var i = 0; i < TIERS.length; i++) if (v > TIERS[i][0]) return TIERS[i]; return TIERS[3]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- gallery ---------- */
  function initGallery(g) {
    if (g.__rr) return; g.__rr = true;
    var track = g.querySelector('.rr-gal__track');
    var slides = [].slice.call(g.querySelectorAll('.rr-gal__slide'));
    var thumbs = [].slice.call(g.querySelectorAll('.rr-gal__thumbs button'));
    var count = g.querySelector('.rr-gal__count b');
    var lb = g.querySelector('.rr-lightbox'), lbImg = lb && lb.querySelector('img');
    var cur = 0;

    function go(i, smooth) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[cur].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      mark();
    }
    function mark() {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === cur ? 'true' : 'false'); });
      if (thumbs[cur]) { var bar = thumbs[cur].parentNode; var tl = thumbs[cur].offsetLeft - bar.offsetLeft;
        if (tl < bar.scrollLeft || tl + thumbs[cur].offsetWidth > bar.scrollLeft + bar.clientWidth) bar.scrollTo({ left: tl - 8, behavior: 'smooth' }); }
      if (count) count.textContent = cur + 1;
    }
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); if (i !== cur) { cur = i; mark(); } }, 60);
    }, { passive: true });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.dataset.i); }); });
    g.querySelectorAll('.rr-gal__stage .rr-gal__arrow').forEach(function (b) { b.addEventListener('click', function () { go(cur + +b.dataset.dir); }); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); } if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); } });

    if (lb && lb.showModal) {
      function show(i) { cur = (i + slides.length) % slides.length; var z = slides[cur].querySelector('.rr-gal__zoom'); if (z) lbImg.src = z.dataset.full; }
      g.querySelectorAll('.rr-gal__zoom').forEach(function (z, k) { z.addEventListener('click', function () { show(k); lb.showModal(); }); });
      lb.querySelectorAll('[data-lb]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); show(cur + +b.dataset.lb); }); });
      lb.querySelector('.rr-lightbox__close').addEventListener('click', function () { lb.close(); });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') show(cur + 1); if (e.key === 'ArrowLeft') show(cur - 1); });
      lb.addEventListener('close', function () { go(cur, false); });
    }
  }

  /* ---------- LED meters ---------- */
  function meterRow(name, i, unit) {
    return '<div class="rr-meter" data-i="' + i + '"><span class="rr-meter__name">' + esc(name) + '</span>' +
      '<div class="rr-leds">' + new Array(25).join('<i></i>') + '</div><span class="rr-meter__num">0<small>' + esc(unit) + '</small></span></div>';
  }
  function setMeter(row, v, max, unit) {
    if (!isFinite(v)) v = 0;
    var capped = Math.min(v, max), fr = capped / max, col = max === MAX ? tier(capped)[2] : tier(fr * MAX)[2];
    var leds = row.querySelectorAll('.rr-leds i');
    var shown = 0; for (var k = 0; k < leds.length; k++) if (leds[k].offsetParent !== null || leds[k].getClientRects().length) shown++;
    shown = shown || leds.length;
    var lit = Math.round(fr * shown);
    for (var j = 0; j < leds.length; j++) leds[j].style.background = j < lit ? col : '';
    var num = row.querySelector('.rr-meter__num');
    num.innerHTML = (max === MAX && v >= MAX ? '360+' : Number(v).toLocaleString()) + '<small>' + esc(unit) + '</small>';
    num.style.color = col;
    row.title = row.querySelector('.rr-meter__name').textContent + ': ' + num.textContent.replace(unit, ' ' + unit);
  }

  function initMeters(el) {
    if (el.__rr) return; el.__rr = true;
    var data; try { data = JSON.parse(el.getAttribute('data-rr-fps')); } catch (e) { el.closest('section') && el.closest('section').remove(); return; }
    var groups = [];
    if (Array.isArray(data)) groups.push({ label: '', games: data, live: true });
    else if (data) {
      if (data.gaming) groups.push({ label: 'Gaming', games: data.gaming, live: true });
      if (data.sim) groups.push({ label: 'Sim racing', games: data.sim, live: true });
      if (data.productivity) groups.push({ label: 'Workstation', games: data.productivity, live: false });
    }
    groups = groups.filter(function (g) { return g.games && g.games.length; });
    if (!groups.length) { el.closest('section') && el.closest('section').remove(); return; }

    var tech = (el.getAttribute('data-fg-tech') || '').trim();
    var hasFg = !!tech && groups.some(function (g) { return g.live && g.games.some(function (x) { return x.fg || x.fgFps; }); });
    var qLabels = (el.getAttribute('data-q-labels') || 'Low|Medium|High').split('|');
    var st = { res: 0, q: 2, fg: false };

    var html = '<div class="rr-ctrl">' +
      '<div class="rr-seg" data-k="res" role="group" aria-label="Resolution">' + ['1080p', '1440p', '4K'].map(function (t, i) { return '<button type="button" data-i="' + i + '" aria-pressed="' + (i === 0) + '">' + t + '</button>'; }).join('') + '</div>' +
      '<div class="rr-seg" data-k="q" role="group" aria-label="Quality">' + qLabels.map(function (t, i) { return '<button type="button" data-i="' + i + '" aria-pressed="' + (i === 2) + '">' + t + '</button>'; }).join('') + '</div>' +
      (hasFg ? '<button type="button" class="rr-fg" aria-pressed="false"><i></i>Frame Gen</button>' : '') + '</div>';
    groups.forEach(function (g, gi) {
      html += '<div class="rr-mgroup" data-g="' + gi + '">' + (groups.length > 1 ? '<div class="rr-mgroup__label">' + esc(g.label) + '</div>' : '') +
        g.games.map(function (x, i) { return meterRow(x.name, i, g.live ? 'FPS' : (x.unit || '')); }).join('') + '</div>';
    });
    html += '<div class="rr-scale" aria-hidden="true"><span></span><div><span>0</span><span>120</span><span>240</span><span>360</span></div><span></span></div>';
    html += '<p class="rr-disc">Estimates. Real results vary by settings, drivers and game version. ' +
      (hasFg ? 'Frame Gen uses ' + esc(tech) + '.' : (tech ? '' : 'This GPU does not support Frame Generation.')) + '</p>';
    el.innerHTML = html;

    function update() {
      groups.forEach(function (g, gi) {
        var rows = el.querySelectorAll('.rr-mgroup[data-g="' + gi + '"] .rr-meter');
        g.games.forEach(function (x, i) {
          if (!rows[i]) return;
          if (!g.live) { setMeter(rows[i], +x.value, +x.max || MAX, x.unit || ''); return; }
          var src = st.fg ? (x.fg || x.fgFps || x.fps) : x.fps;
          var v = src && src[st.res] ? src[st.res][st.q] : 0;
          setMeter(rows[i], +v, MAX, 'FPS');
        });
      });
    }
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.rr-seg button');
      if (b) { st[b.parentNode.dataset.k] = +b.dataset.i; b.parentNode.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', x === b); }); update(); return; }
      var f = e.target.closest('.rr-fg');
      if (f) { st.fg = !st.fg; f.setAttribute('aria-pressed', st.fg); update(); }
    });
    requestAnimationFrame(update);
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (Math.abs(window.innerWidth - lastW) > 40) { lastW = window.innerWidth; update(); } });
  }

  /* ---------- rating link → Google reviews section ---------- */
  function initReviews(a) {
    if (a.__rr) return; a.__rr = true;
    a.addEventListener('click', function (e) {
      var target = document.querySelector('[id*="google_reviews"], [id$="1742947229ce77da9c"], .shopify-section [class*="google-review"]');
      if (target) { e.preventDefault(); var s = target.closest('.shopify-section') || target; s.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  function run() {
    document.querySelectorAll('[data-rr-gal]').forEach(initGallery);
    document.querySelectorAll('.rr-meters[data-rr-fps]').forEach(initMeters);
    document.querySelectorAll('[data-rr-reviews]').forEach(initReviews);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();


/* RR: "fling" the rig into the cart folder on Add to cart (2026-10-08).
   A thumbnail of the current gallery photo arcs from the button to the sidebar/top-bar folder,
   then the folder's own drop-in + badge pop play (sections/sidebar.liquid). The theme's cart drawer
   is held until the thumbnail lands so it doesn't cover the flight. Skipped for reduced motion. */
(function () {
  if (window.__rrFling) return;
  window.__rrFling = true;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 650;

  function visible(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0 && r.bottom > 0 && r.top < innerHeight ? r : null; }
  function currentPhoto() {
    var track = document.querySelector('.rr-gal__track');
    if (!track) return null;
    var imgs = track.querySelectorAll('img'), tr = track.getBoundingClientRect(), best = null, bestD = 1e9;
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect(), d = Math.abs(r.left - tr.left);
      if (r.width && d < bestD) { bestD = d; best = imgs[i]; }
    }
    return best;
  }
  function holdDrawer(ms) {
    var d = document.querySelector('.sidebar__cart');
    if (!d || typeof d.show !== 'function') return;
    if (!d.__rrOrigShow) {
      d.__rrOrigShow = d.show;
      d.show = function () {
        var self = this, args = arguments, wait = (window.__rrFlingUntil || 0) - Date.now();
        if (wait > 0) setTimeout(function () { self.__rrOrigShow.apply(self, args); }, wait);
        else self.__rrOrigShow.apply(self, args);
      };
    }
    window.__rrFlingUntil = Date.now() + ms;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.rr-pp__cart') : null;
    if (!btn || btn.disabled || btn.classList.contains('disabled') || reduce) return;
    var folder = document.querySelector('.rr-cartf .rr-cartf__icon');
    var to = folder && visible(folder);
    var from = btn.getBoundingClientRect();
    var photo = currentPhoto();
    if (!to || !photo || !photo.animate) return;

    var size = Math.min(96, from.height * 1.6);
    var ghost = document.createElement('img');
    ghost.src = photo.currentSrc || photo.src;
    ghost.alt = '';
    ghost.setAttribute('aria-hidden', 'true');
    ghost.className = 'rr-fling';
    ghost.style.width = ghost.style.height = size + 'px';
    var x0 = from.left + from.width / 2 - size / 2, y0 = from.top + from.height / 2 - size / 2;
    var x1 = to.left + to.width / 2 - size / 2, y1 = to.top + to.height / 2 - size / 2;
    var peak = Math.max(4, Math.min(y0, y1) - Math.max(80, Math.abs(x1 - x0) * 0.25));   /* arc apex above both points, kept on screen */
    ghost.style.left = x0 + 'px';
    ghost.style.top = y0 + 'px';
    document.body.appendChild(ghost);
    holdDrawer(DUR + 80);

    var steps = [], n = 12;
    for (var i = 0; i <= n; i++) {
      var t = i / n, u = 1 - t;
      var x = (x1 - x0) * t;
      var y = u * u * 0 + 2 * u * t * (peak - y0) + t * t * (y1 - y0);   /* quadratic bezier */
      var sc = 1 - 0.78 * t;
      steps.push({ transform: 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(' + sc.toFixed(3) + ') rotate(' + (-18 * t).toFixed(1) + 'deg)', opacity: t > 0.9 ? (1 - t) * 10 : 1 });
    }
    var a = ghost.animate(steps, { duration: DUR, easing: 'cubic-bezier(.45,.05,.55,1)', fill: 'forwards' });
    a.onfinish = a.oncancel = function () { ghost.remove(); };
  }, true);
})();

/* RR: open the cart drawer after Add to cart on the custom product page (2026-10-08).
   The theme only does this inside <product-page> (main-product.liquid); rr-product.liquid isn't wrapped in it,
   so the item was added but the cart stayed shut. If a fling is in flight, the drawer waits for it to land. */
(function () {
  if (window.__rrCartOpen) return;
  window.__rrCartOpen = true;
  function bind() {
    var f = document.querySelector('.rr-pp__form');
    if (!f || f.__rrBound || !(window.KROWN && KROWN.settings && KROWN.settings.cart_action === 'overlay')) return;
    f.__rrBound = true;
    f.addEventListener('add-to-cart', function () {
      var d = document.querySelector('.sidebar__cart');
      if (!d || typeof d.show !== 'function') return;
      if (window.preloadImages) window.preloadImages(d);
      var wait = (window.__rrFlingUntil || 0) - Date.now();
      setTimeout(function () { (d.__rrOrigShow || d.show).call(d); }, Math.max(0, wait));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind); else bind();
})();
